import { getActionType } from './utils';

const initialState = {
  context: {},
  createdUser: {},
  affiliationInfo: {},

  affiliations: {
    employers: [],
    heSchools: [],
    district: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case getActionType('populateContext'):
      return {
        ...state,
        context: action.context,
      };

    case getActionType('populateCreatedUser'):
      return {
        ...state,
        createdUser: action.createdUser,
      };

    case getActionType('populateAffiliationInfo'):
      return {
        ...state,
        affiliationInfo: action.affiliationInfo,
      };

    case getActionType('populateAffiliations'):
      return {
        ...state,
        affiliations: action.affiliations,
      };

    default:
      return state;
  }
};
